import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AddIcon from "@mui/icons-material/Add";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton } from "../../../utils/Custom/Button";
import { headingTypes } from "./editQuotation";
import { clienTypes } from "../../../utils/commonComponent/common";
import { getPermissions } from "../rbac/hasAccess";
import { formateDate, paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";
import moment from "moment";
import { IconButton, Menu, MenuItem, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { AutoCompletes } from "../../../utils/Custom/custominput";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const headers = ["id", "Client", "quotationNumber", "date", "quotationType"];

const fields = [{ value: "client", label: "Client" },
{ value: "quotationNumber", label: "Quotation Number" }
];

const getContactPerson = (value) => {
  try {
    const data = typeof value === "string" ? JSON.parse(value) : value;
    return data?.[0] || {};
  } catch {
    return {};
  }
};

const QuotationList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/quotation/${row.id}`);
  const followUpEnquiry = (row) => navigate(`/quotationFollowUp/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("quotation", row.id);

  const [quotationList, setQuotationList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [allQuotationData, setAllQuotationData] = useState([]);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
console.log({allQuotationData})
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);

  // Menu states
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);  
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handleStatusOpen = (row) => {
    setSelectedQuotation(row);
    setSelectedStatus(row.conversionStatus || "");
    setStatusModalOpen(true);
  };

  const handleStatusClose = () => {
    setStatusModalOpen(false);
    setSelectedQuotation(null);
    setSelectedStatus("");
  };

  const updateQuotationStatus = async () => {
    try {
      if(selectedStatus != "Remove Status") {
        const poData = await fetchQuery(`SELECT id FROM poAcceptance WHERE quotationId = ${selectedQuotation.id} LIMIT 1;`);
        if (poData?.length > 0) {
          alert("PO is already created for this quotation.");
          return;
        }
      }
      await fetchQuery(`UPDATE quotation SET conversionStatus = ${selectedStatus === "Remove Status" ? "NULL" : `'${selectedStatus}'`} WHERE id=${selectedQuotation.id};`);
      fetchQuotationList();
      handleStatusClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };
  
  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      // client: "cl.companyName",
      client: "qt.clientId",
      quotationNumber: "qt.quotationNumber",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `where LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    return whereConditions;
  };
  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    // return `SELECT qt.*, cl.type as clientType, cl.companyName as Client FROM quotation qt left JOIN clients cl ON qt.clientId = cl.id ${whereClause} ORDER BY qt.id DESC ${paginationSettings};`;
    return `SELECT qt.* FROM quotation qt  ${whereClause} ORDER BY qt.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    // return `SELECT COUNT(*) AS totalRows FROM quotation qt left JOIN clients cl ON qt.clientId = cl.id ${whereClause};`;
    return `SELECT COUNT(*) AS totalRows FROM quotation qt ${whereClause};`;
  };

  const fetchQuotationList = async () => {
    try {
      const allDataQuery = fetchAllQuotationData();
      const [quotationData, countResult, allQuotationData] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery(allDataQuery)
      ]);

      const modified = quotationData?.map((item) => {
        const typeObj = headingTypes.find(ht => ht.id == item.quotationType);

        return {
          ...item,
          quotationType: typeObj?.label || "",
          Client: item.clientId,
          // Client: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
        };
      });

      const modifiedAllQuote = allQuotationData?.map((item) => {
        const typeObj = headingTypes.find(ht => ht.id == item.quotationType);
        const contactPerson = getContactPerson(item.contactPerson);

        return {
          Client: item.clientId,
          quotationNumber: item.quotationNumber,
          date: item.date ? moment(item.date).format("DD-MM-YYYY") : "",
          contactPersonName: contactPerson.contactPersonName || "",
          contact: contactPerson.contact || "",
          emailId: contactPerson.emailId || "",
        };
      });
      setQuotationList(modified);
      setTotalRows(countResult?.[0]?.totalRows || 0);
      setAllQuotationData(modifiedAllQuote)
    } catch (error) {
      console.error("Error fetching quotationData data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchQuotationList();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("client");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const fetchAllQuotationData = () => {
    const whereClause = getWhereClause();
      return `SELECT qt.*, cl.type as clientType, cl.companyName as Client FROM quotation qt left JOIN clients cl ON qt.clientId = cl.id ${whereClause} ORDER BY qt.id DESC`; };

  useEffect(() => {
    fetchQuotationList();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchQuotationList();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/quotation/0"
          label="Add Quotation"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Quotation"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        showExcelDownload={permissions.excelDownload || permissions.allAccess}
        finalData={allQuotationData}
        notNeededColumn={[]}
      />


      <div className="w-full border rounded-md shadow">
        {/* Table Container with Fixed Height */}
        <div className="overflow-y-auto h-auto max-h-[450px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Client</th>
                <th className="px-4 py-3 whitespace-nowrap">Quotation Number</th>
                <th className="px-4 py-3 whitespace-nowrap">Date</th>
                <th className="px-4 py-3 whitespace-nowrap">Contact Person</th>
                <th className="px-4 py-3 whitespace-nowrap">Contact Number</th>
                <th className="px-4 py-3 whitespace-nowrap">Email ID</th>
                <th className="px-4 py-3 whitespace-nowrap">Status</th>
                {(permissions.edit || permissions.view || permissions.delete || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center">ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {quotationList.length > 0 ? (
                quotationList.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                    <td className="px-4 py-3">{row.Client || ""}</td>
                    <td className="px-4 py-3">{row.quotationNumber || ""}</td>
                    <td className="px-4 py-3">{formateDate(row.date)}</td>
                   <td className="px-4 py-3">{getContactPerson(row.contactPerson).contactPersonName || ""}</td>
                    <td className="px-4 py-3">{getContactPerson(row.contactPerson).contact || ""}</td>
                    <td className="px-4 py-3">{getContactPerson(row.contactPerson).emailId || ""}</td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <span>{row.conversionStatus || "-"}</span>
                        <Tooltip title="Change Status">
                          <IconButton
                            size="small"
                            onClick={() => handleStatusOpen(row)}
                          >
                            <AutorenewIcon fontSize="small" className="text-blue-600" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                    {(permissions.edit || permissions.view || permissions.delete || permissions.allAccess) && (
                      <td className="px-4 py-2 text-center whitespace-nowrap">
                        <div className="flex items-center justify-center gap-2">
                          {(permissions.edit || permissions.allAccess) && (
                            <Tooltip title="Edit" placement="top-start">
                            <button
                              onClick={() => handleEdit(row)}
                              className="text-blue-600"
                            >
                              <EditIcon fontSize="small" />
                            </button>
                            </Tooltip>
                          )}
                          {(permissions.edit || permissions.allAccess) && (
                            <Tooltip title="Quotation FollowUp" placement="top-start">
                              <button
                                onClick={() => followUpEnquiry(row)}
                                className="text-blue-600"
                              >
                                <BookmarkIcon fontSize="small" />
                              </button>
                            </Tooltip>
                          )}
                          {(permissions.delete || permissions.allAccess) && (
                            <Tooltip title="Delete" placement="top-start">
                            <button
                              onClick={() => handleDelete(row)}
                              className="text-blue-600"
                            >
                              <DeleteIcon fontSize="small" />
                            </button>
                            </Tooltip>
                          )}
                          {(permissions.pdfDownload || permissions.allAccess) && (
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, row)}
                              className="text-blue-600"
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          )}
                          <Menu
                            anchorEl={menuAnchorEl}
                            open={Boolean(menuAnchorEl && menuRow === row)}
                            onClose={handleMenuClose}
                          >
                            {(permissions.pdfDownload || permissions.allAccess) && (
                              <MenuItem
                                onClick={() => {
                                  handleMenuClose();
                                  navigate(`/viewQuotation/${menuRow.id}`);
                                }}
                              >
                                <PictureAsPdfIcon
                                  fontSize="small"
                                  className="text-blue-600 mr-2"
                                />
                                Pdf
                              </MenuItem>
                            )}
                          </Menu>
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>

        <Dialog
          open={statusModalOpen}
          onClose={handleStatusClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Update Quotation Status</DialogTitle>
          <DialogContent>
            <div className="mt-2">
              <AutoCompletes
                label="Status"
                options={[
                  // { id: 1, label: "Interested" },
                  { id: 2, label: "Not Interested" },
                  { id: 3, label: "Remove Status" },
                ]}
                valueKey="label"
                labelKey="label"
                value={selectedStatus}
                onChange={(val) => setSelectedStatus(val)}
                isWidth
              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleStatusClose}>Cancel</Button>
            <Button
              variant="contained"
              onClick={updateQuotationStatus}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default QuotationList;
